
import React , {Component} from 'react';
import axios from 'axios';
// import  url from '../url';
import './tablehover.css';
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'

const $ = require('jquery');
$.DataTable = require('datatables.net');

require( 'datatables.net-buttons/js/dataTables.buttons.min' );
const jzip = require( 'jzip');
require( 'datatables.net-buttons/js/buttons.html5.min' );

window.JSZip = jzip;

export default class BooksDatatable extends Component{

    constructor(props){
        super(props);
        this.reloadTableData = this.reloadTableData.bind(this);
        this.updateTable = this.updateTable.bind(this);
    }
    componentDidMount(){
        var colArr = [];
        this.props.columns.map(value =>{
            // console.log(value)
            if(value=='title'){
                colArr.push({title:value, width:200});

            }else{
                colArr.push({title:value});

            }
        })
        this.$el = $(this.el);
        this.$el.DataTable({
            
            "sPaginationType": "full_numbers",
            data:[],
            columns:colArr,
            columnDefs: [
                {
                    targets:2,
                    width:200
                },
                {
                    targets: '_all',
                    className: 'dt-center'
                }
              ],
            paging:this.props.paging,
            dom: 'Blfrtip',
            order:[[3,"desc"]],
            buttons: [
                'csvHtml5'
            ]
            
        })
        if(this.props.tData.length > 0){
            var t = this.$el.DataTable();
            console.log('map and aff')
            this.props.tData.map(data => {
                t.row.add(data).draw();
            })
        }
        const ta = this.$el.dataTable()
        var that = this;
        console.log('mount')
        $(document).ready(() => {
            console.log('here')
            $('table').on('change', 'input', function () {
                var isbn = $(this).val();
                that.props.changedIsbn(isbn,this)
            })

            $('table').on('click', '#batchChoosen', function () {
                var val = $(this).attr("data-id");
                // that.props.deleteProp(val)
                window.location = '/donated_books?id='+val
            })

            $('table').on('click', '#download', function () {
                var val = $(this).attr("data-id");
                that.props.download(val)
                // window.location = '/donated_books?id='+val
            })

            $('table').on('click', '#batchName', function () {
                var val = $(this).attr("data-isbn");
                var val_id = $(this).attr("data-id");

                console.log(val)
                that.props.getIsbnDetails(val,val_id)
                // window.location = '/donated_books?id='+val
            })



            $('table').on('click', '#bookedOrder', function () {
                var obj = {
                    "id": $(this).attr("data-id"),
                    "sku":$(this).attr("data-sku"),
                    "name":$(this).attr("data-name"),
                    "qty":$(this).attr("data-qty"),
                    "mrp":$(this).attr("data-mrp"),
                    "discount":$(this).attr("data-discount")
                }
                console.log(obj)
                that.props.getItemOrderDetails(obj)
            })

            
            

            if(this.props.updateSubTotal){
                console.log('inside ')
                $('table').on('change', 'input', function () {
                    let t = $('#tbl').DataTable();
                    // console.log(t.row.find(".subtotal"))
                    var parentRow = t.row( $(this).closest('tr') ).index()
                    var qtyvalue = $(this).val();
                    var mrp = $(this).attr("data-mrp");
                    var discount = $(this).attr("data-disc");

                    var  subtotal = qtyvalue * (mrp - (mrp * discount/100))
                    var subtotalRoundOff = subtotal.toFixed(2)

                    try{
                        t.cell(parentRow,6).data(`<span><i class="fa fa-rupee"></i>  ${subtotalRoundOff}</span>`).draw()
                    }catch(e){
                        console.log(e)
                    }
                })  
            }
                
        });
    }

    reloadTableData(names) {
        // console.log('control in reload tables')
        const table = this.$el.DataTable();
        table.clear();
        table.rows.add(names);
        table.draw();
        if(this.props.getTableInstance){
            this.props.getTableInstance(table)

        }
    }

    updateTable(names) {
        console.log('inside updatetable')
        const table = this.$el.DataTable();
        // $('.data-table-wrapper')
        //               .find('table')
        //               .DataTable();
        let dataChanged = false;
        table.rows().every(function () {
            console.log(this.data())
            const oldNameData = this.data();
            
            const newNameData = names.find((nameData) => {
                return nameData.id === oldNameData.id;
            });
            if (oldNameData.status !== newNameData.status) {
                dataChanged = true;
                this.data(newNameData);
            }
            return true; 
        });
    
        if (dataChanged) {
            table.draw();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.tData.length !== this.props.tData.length) {
            // console.log('calling reloadtable ')
            this.reloadTableData(nextProps.tData);
        } 
        return false;
    }

    componentWillUnmount(){
        this.$el.find('table')
        .DataTable()
        .destroy(true);
        // DataTable().destroy(true);
    }

    render(){
        return <div>
            <table className="cell-border dataTable display" id = "tbl" ref = {el => this.el = el}></table>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/Components/AddBooksToTitle/booksDatatable.js